import { render } from "./CometChatBanGroupMemberList.vue?vue&type=template&id=7a00556a&scoped=true"
import script from "./CometChatBanGroupMemberList.vue?vue&type=script&lang=js"
export * from "./CometChatBanGroupMemberList.vue?vue&type=script&lang=js"

import "./CometChatBanGroupMemberList.vue?vue&type=style&index=0&id=7a00556a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a00556a"]])

export default __exports__